import React, { useState } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import OperationPanel from "../../../components/Common/OperationPanel";
import CommonModal from "../../../components/Common/CommonModal";
import DepartmentList from "./DepartmentList";
import DepartmentForm from "./DepartmentForm";
import DepartmentTabs from "./DepartmentTabs";

const Index = () => {
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [tab, setTab] = useState("active"); 
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [mode, setMode] = useState("create"); 
  return (
    <div className="page-content">
      <Breadcrumbs title="Organization" breadcrumbItem="Departments" />

      <OperationPanel
        search={search}
        setSearch={setSearch}
        addLabel="Add Department"
        onAdd={() => { setMode("create"); setSelectedDepartment(null); setModal(true); }}
      />

      <DepartmentTabs tab={tab} setTab={setTab} />

      <DepartmentList search={search} refresh={refresh} tab={tab} setMode={setMode} setSelectedDepartment={setSelectedDepartment} setModal={setModal} />
      <CommonModal
        isOpen={modal}
        toggle={() => setModal(false)}
        title="Create Department"
      >
       <DepartmentForm
          isModal
          mode={mode}
          selectedDepartment={selectedDepartment}
          onSuccess={() => {
            setModal(false);
            setRefresh(prev => !prev);
          }}
        />
      </CommonModal>
    </div>
  );
};

export default Index;